const { getOffsetTop } = window.BAO.Utils

class FixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setVisibility()
  }

  setVisibility () {
    this.setAttribute('aria-hidden', !this.shouldBeVisible)
  }

  get shouldBeVisible () {
    if (!this.externalEls?.top?.exists) return

    const topStart = this.externalEls.top.element
    const bottomEnd = this.externalEls.bottom.element

    if (
      this.lastKnownY > getOffsetTop(topStart) + topStart.offsetHeight - 300 &&
      this.lastKnownY < getOffsetTop(bottomEnd) - window.innerHeight - 300
    ) {
      return true
    } else {
      return false
    }
  }
}

if (!customElements.get('fixed-bar')) {
  customElements.define('fixed-bar', FixedBar)
}
